import { render, staticRenderFns } from "./objects.vue?vue&type=template&id=08f8583c"
import script from "./objects.vue?vue&type=script&lang=js"
export * from "./objects.vue?vue&type=script&lang=js"
import style0 from "./objects.vue?vue&type=style&index=0&id=08f8583c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports